
function transitionNumber({ oldValue, newValue, duration, callback }) {
  oldValue = Number(oldValue)
  newValue = Number(newValue)

  const difference = newValue - oldValue

  let startTime = new Date()

  requestAnimationFrame(function animate() {

    let endTime = new Date()

    let p = (endTime - startTime) / duration

    p = p > 1 ? 1 : p

    let value = Number(oldValue + p * difference)
    let val = Number.isNaN(value) ? '--' : value.toFixed(0)
    callback && callback(val)

    if (p < 1) {
      requestAnimationFrame(animate)
    } else {
      // let val = Number.isNaN(newValue) ? '--' : newValue.toLocaleString('zh-CN', {
      //   minimumFractionDigits: 2,
      //   maximumFractionDigits: 2,
      // })
      let val = Number.isNaN(newValue) ? '--' : newValue.toLocaleString()
      callback && callback(val)
    }
  })
}

export { transitionNumber }
